// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__L2Vtu","main":"Layout_main__RIY09"};